function currencyConverter(amount, currency) {

    let currencyAmount = '';
    switch (currency) {
        case 'CAD':
            currencyAmount = (Number(amount)).toLocaleString("en-ca", {
                style: "currency",
                currency: "CAD",
            });
            break;

        case 'INR':
            currencyAmount = (Number(amount)).toLocaleString("en-US", {
                style: "currency",
                currency: "INR",
            });
            break;

        default:
            currencyAmount = (Number(amount)).toLocaleString("en-US", {
                style: "currency",
                currency: "INR",
            });
            break;
    }

    return currencyAmount;
}


export default currencyConverter;